import { NgClass } from '@angular/common';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, inject, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FileUploadComponent, FileUploadValidators } from '@iplab/ngx-file-upload';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Observable, of } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { PaperType } from '../../../../_shared/enums/PaperType.enum';
import { Event, PortfolioPaper, Subcontractor } from '../../../../_shared/model';
import { TelemedRead } from '../../../../_shared/model/inbox/telemedRead.model';
import { OpenDocumentRequest } from '../../../../_shared/model/utils/openDocumentRequest.model';
import { DatePipe } from '../../../../_shared/pipes/date.pipe';
import { HelperService, MfToastService, StorageService } from '../../../../_shared/services';
import { Helpers } from '../../../../helpers';
import { CommonService, DocumentsService, ResultService } from '../../home/_services';
import { InboxService } from '../../home/_services/inbox.service';
import { FileSource } from '../enums/file-source.enum';
import { DocumentData } from '../model/document-data.model';
import { WebSocketChat } from '../model/web-socket-chat.model';
import { TelemedicineService } from '../telemedicine.service';

@Component({
    selector: 'telm-chat',
    templateUrl: './telm-chat.component.html',
    styleUrls: ['./telm-chat.component.scss'],
    imports: [NgClass, ReactiveFormsModule, NgbTooltip, FileUploadComponent, DatePipe],
})
export class TelmChatComponent implements OnInit {
    private wscs = inject(TelemedicineService);
    private storage = inject(StorageService);
    private fb = inject(UntypedFormBuilder);
    private changeDetectorRef = inject(ChangeDetectorRef);
    private docApi = inject(DocumentsService);
    private helper = inject(HelperService);
    private common = inject(CommonService);
    private inboxRest = inject(InboxService);
    private toaster = inject(MfToastService);
    private rest = inject(ResultService);

    @Input()
    set termData(data: Event) {
        if (data !== undefined) {
            this.selectedTerm = data;
            this.init();
        }
    }

    public selectedTerm: Event;
    public chatData$: Observable<WebSocketChat[]>;
    public chatData: WebSocketChat[] = [];
    public isLoaded = false;
    public isFileUpload = false;
    public chatForm: UntypedFormGroup;
    public isUploading = false;
    public subcontractor: Subcontractor;
    @ViewChild('scrollMe') private myScrollContainer: ElementRef;
    @ViewChild('fileUploadComponent') private uploadFile: FileUploadComponent;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @ViewChildren('chatList') chatList: QueryList<any>;

    ngOnInit(): void {
        //    this.init();
        this.inboxRest
            .setTelemedicineRead(
                this.selectedTerm?.contractor?.id,
                new TelemedRead().deserialize({
                    unreads: [
                        {
                            prereservationId: this.selectedTerm.prereservationId,
                        },
                    ],
                }),
            )
            .subscribe();

        //TODO treba dobit st. neprebranih
        // this.store.dispatch(new WebsocketActions.Telemedicine.ResolveNotifications(1))

        this.wscs.chatDataFromOtherComponents.subscribe(data => {
            if (data) {
                data.forEach(doc => {
                    this.chatData.push(
                        new WebSocketChat().deserialize({
                            chat: null,
                            source: 'DOCTOR',
                            eventTime: new Date(),
                            document: doc?.document,
                        }),
                    );
                });
            }
        });
    }

    private init(): void {
        if (!this.selectedTerm) {
            return;
        }
        this.common
            .getSubcontractor(this.selectedTerm?.contractor?.id, this.selectedTerm?.contractor?.subcontractors[0]?.id)
            .subscribe((subcontracotr: Subcontractor) => {
                this.subcontractor = subcontracotr;
                this.chatData = [];
                // this.chatData$ =
                this.createForm();
                this.wscs
                    .getChatData(this.selectedTerm.prereservationId)
                    .pipe(
                        tap((chat: WebSocketChat[]) => {
                            if (this.chatData && chat) {
                                this.chatData.push(...(chat || []));
                            } else {
                                this.chatData = chat;
                            }
                        }),
                    )
                    .subscribe(() => {
                        this.scrollToBottom();
                        this.isLoaded = true;
                    });
            });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public openDocument(document: any): void {
        if (document.fileSource == FileSource.PAPER) {
            this.openPreview(document);
        } else {
            this.docApi
                .openDocument(this.storage.getSelectedContractor().id, document.documentId)
                .pipe(
                    filter(res => res.type == HttpEventType.Response),
                    map(res => {
                        return new Blob([res.body], { type: res.body.type });
                    }),
                )
                .subscribe(
                    res => {
                        const data: OpenDocumentRequest = new OpenDocumentRequest().deserialize({
                            document: res,
                        });
                        this.helper.openDocumentViewerSimple(data, document.fileName);
                    },
                    () => {},
                );
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public openPreview(paper: PortfolioPaper | any, print = false): void {
        let dataCall$;
        const id = paper.documentId !== undefined ? paper.documentId : paper.id;
        switch (paper.fileName) {
            case PaperType.FTH_POROCILO:
            case PaperType.IZVID:
            case PaperType.CONFIRM_VISIT:
            case PaperType.HELLODOC_IZVID:
            case PaperType.MFMEDICAL_IZVID:
            case PaperType.MEDIFIT_MEDICAL_REPORT:
                if (typeof id === 'number') {
                    dataCall$ = this.rest.getSurveyPaperPreviewReservation(this.selectedTerm?.prereservationId, id);
                } else {
                    dataCall$ = this.rest.getSurveyPaperPreviewReservationMasked(this.selectedTerm?.prereservationId, id);
                }
                break;
            case PaperType.WHITE_REFERRAL:
            case PaperType.HELLODOC_REFERRAL:
            case PaperType.HELLODOC_ORDERFORM_LAB:
            case PaperType.HELLODOC_ORDERFORM_DIAG:
                if (typeof id === 'number') {
                    dataCall$ = this.rest.printPortfolioPaper(this.storage.getSelectedContractor().id, id);
                } else {
                    dataCall$ = this.rest.printWhiteReferralMasked(this.storage.getSelectedContractor().id, id);
                }
                break;
            case PaperType.CONFIRM_RESERVATION:
                if (typeof id === 'number') {
                    dataCall$ = this.rest.getSurveyPaperPreviewReservation(this.selectedTerm?.prereservationId, id);
                } else {
                    dataCall$ = this.rest.getSurveyPaperPreviewReservationMasked(this.selectedTerm?.prereservationId, id);
                }
                break;
            default:
                dataCall$ = of({ type: 0 });
                break;
        }

        dataCall$
            .pipe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                map((res: any) => {
                    if (res.type !== 0) {
                        return new Blob([res.body], { type: 'application/pdf' });
                    }
                }),
            )
            .subscribe(
                res => {
                    if (res) {
                        this.helper.openDocumentViewer(res, res.type, 'Izvid', print);
                    }
                },
                () => {
                    Helpers.setLoading(false);
                },
            );
    }
    public upload(): void {
        this.isFileUpload = true;
        this.changeDetectorRef.detectChanges();
        this.uploadFile.control().click();
    }

    public sendMessage(): void {
        const formData: { message: string; uploadFile: File[] } = this.chatForm.value;
        const isDocument: boolean = formData.uploadFile.length > 0;
        const isMessage: boolean = formData.message != '';
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let uploadFile$: Observable<any>[] = [of(undefined)];
        // if (isMessage || isDocument) {
        if (isDocument) {
            uploadFile$ = formData.uploadFile.map(file =>
                this.docApi.uploadFile(file, '').pipe(
                    filter(res => res.type == HttpEventType.Response),
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    map((response: HttpResponse<any>) => {
                        return { id: response.body, file: file };
                    }),
                ),
            );
        } else {
            if (!isMessage) return;
        }
        // isDocument
        //     ? this.commonApi.uploadFile(this.guid, formData.uploadFile[0]).pipe(
        //           tap(() => (this.isUploading = true)),
        //           filter((res) => res.type == HttpEventType.Response)
        //       )
        //     : of(undefined);

        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        forkJoin(uploadFile$).subscribe((document: any[]) => {
            // const newMesage: WebSocketChat = new WebSocketChat().deserialize({
            //     chat: formData.message,
            // });
            const newMesage: WebSocketChat = new WebSocketChat().deserialize({
                chat: formData.message,
                source: 'DOCTOR',
                eventTime: new Date(),
            });

            let documentData: DocumentData[] = [];
            if (isDocument) {
                this.isUploading = false;
                documentData = document.map(doc => {
                    return new DocumentData().deserialize({
                        documentId: doc?.id,
                        description: null,
                        contentType: doc?.file?.type,
                        fileName: doc?.file?.name,
                    });
                });
            }
            this.chatData.push(
                newMesage,
                ...(documentData.map(doc => {
                    return new WebSocketChat().deserialize({
                        chat: null,
                        source: 'DOCTOR',
                        eventTime: new Date(),
                        document: doc,
                    });
                }) || []),
            );
            this.wscs.sendChatSocketMessage(this.selectedTerm.prereservationId, formData.message, documentData);
            this.chatForm.reset({ uploadFile: [] });
        });
    }

    private createForm(): void {
        if (!this.chatForm) {
            this.chatForm = this.fb.group({
                message: this.fb.control({ value: '', disabled: false }),
                uploadFile: this.fb.control({ value: [], disabled: false }, FileUploadValidators.filesLimit(2)),
            });
        }
    }
    private scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line no-empty
        } catch {}
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public saveDocumentToCustomer(document: any) {
        this.docApi.addFileToCustomer(this.storage.getSelectedContractor().id, this.selectedTerm?.customer?.id, document.documentId).subscribe(
            () => {
                this.toaster.success('Dokument dodan na stranko.');
            },
            err => {
                if (this.helper.checkStructError(err, 'addCustomerDocument')) {
                    this.toaster.warning('Dokument je že shranjen na stranki.');
                } else {
                    this.toaster.error('Napaka pri povezovanju dokumenta na stranko.');
                }
            },
        );
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public deleteDocumentFromChat(document: any) {
        this.docApi
            .deleteDocumentFromTelemedChat(this.storage.getSelectedContractor().id, this.selectedTerm.prereservationId, document.documentId)
            .subscribe(
                () => {
                    this.toaster.success('Dokument uspešno izbrisan.');
                    const element = this.chatData.find(el => {
                        if (el?.document == document) {
                            return el;
                        }
                    });
                    this.chatData.splice(this.chatData.indexOf(element), 1);
                },
                () => {
                    this.toaster.error('Napaka pri brisanju dokumenta.');
                },
            );
    }
}
